import { testIsObject, testObjectHasKey } from '../../lib/test-and-assert/test-base';
import { axiosWrapper } from '../../lib/axios-wrapper/axios-wrapper';
import { satGlobals } from '../../qaamgo/sat/helper/sat-globals';
import { userManager } from '../user/user-manager';
import {csrfManager} from "../csrf/csrf-manager";

async function init(operation) {
    const votingStatus = await checkVotingStatus(operation);

    $('.rating-loader').addClass('hidden');
    $('.rating-notice').removeClass('hidden');
    if (votingStatus.visited === true && votingStatus.voted === false) {
        $('.rating-notice').addClass('hidden');
        $('.star-under').addClass('rate-btn');
        $('.rate-btn').on('click', async function () {
            const csrfToken = await csrfManager.getCsrfFeedback();
            let feedbackData = {
                operation: operation,
                _csrf: csrfToken,
            };

            feedbackData.rating = $(this).attr('data-rating');
            feedbackData.feedback = '';

            var apiUrl = sat.apiUrl;

            $.post({
                url: apiUrl + '/api/feedback',
                data: feedbackData,
                dataType: 'json',
                xhrFields: {
                    withCredentials: true,
                },
            })
                .done(function () {
                    $('.rating-container').addClass('hidden');
                    $('.feedback-sent-text').removeClass('hidden');
                    $('.tooltip').tooltip('hide');
                })
                .fail(function (jqXHR, textStatus, errorThrown) {});
        });
    }

    if (votingStatus.voted === true) {
        $('.rating-done-notice').removeClass('hidden');
        $('.star-under').removeClass('rate-btn');
        $('.rating-notice').addClass('hidden');
        $('.star-under').tooltip('disable');
    }
}

async function checkVotingStatus(operation) {
    const user = await userManager.getUser();

    const visited = user._extra.visited_resultpage;

    let voted = false;

    let votingData = user._extra.user_voted;

    if (testIsObject(votingData) && testObjectHasKey(votingData, operation)) {
        voted = votingData[operation];
    }

    return {
        visited: visited,
        voted: voted,
    };
}

var ratingHelper = {
    init: init,
};

export { ratingHelper };
